import React from "react";
import { FlatButton, TextField } from "material-ui";
import moment from "moment";

import connectToStores from "alt-utils/lib/connectToStores";
import BoxOfficeActions from "../../../actions/BoxOfficeActions";
import BoxOfficeStore from "../../../stores/BoxOfficeStore";

import CurrencyField from "../currency-field.jsx";
import LinkLike from "../link-like.jsx";
import BaseOverlay from "../overlays/base.jsx";
import InlineNoticeLabel from "../inline-notice-label.jsx";

import { formatPrice } from "../../../util";

const BASE_STYLE = {
  marginLeft: 10,
  display: "inline-block",
  padding: "5px 10px",
  borderRadius: 5,
  background: "#fff",
  boxShadow: "0px 0px 7px 1px rgba(0,0,0,0.2)"
};

class DisplayModeControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getStores() {
    return [BoxOfficeStore];
  }

  static getPropsFromStores() {
    let state = BoxOfficeStore.getState();
    return state;
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentWillMount() {}

  componentWillReceiveProps(props) {}

  render() {
    const { displayMode } = this.props;

    return (
      <div style={Object.assign({}, BASE_STYLE)}>
        <span>
          <strong>{displayMode === "pos" ? "POS" : "Web"} mode</strong>
          {displayMode === "pos" ? (
            <InlineNoticeLabel label="BETA" style={{ marginLeft: 4 }} />
          ) : null}{" "}
          &middot;{" "}
          <LinkLike
            onTouchTap={() => {
              BoxOfficeActions.setDisplayMode(
                displayMode === "pos" ? "basic" : "pos"
              );
            }}
          >
            Switch to {displayMode === "pos" ? "web" : "POS"}
          </LinkLike>
        </span>
      </div>
    );
  }
}

export default connectToStores(DisplayModeControl);



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-display-mode-control.jsx